const styles = theme => ({
  root: {
    width: '100%', // Full width on mobile
    maxWidth: 1200,
    marginTop: 40,
    height: 'auto',
    marginBottom: '20px',
  },
  title: {
    fontSize: '24px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '16px',
    textAlign: 'center',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Centering the content horizontally
    flexDirection: 'row', // Ensure items are in a row
    width: '100%', // Full width on mobile
    maxWidth: 1200,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  boxPlan: {
    display: 'flex',
    padding: '0px 16px',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '12px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },
  switchLabel: {
    fontSize: '18px',
    height: '30px',
  },
  currently: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '36px' /* 257.143% */,
  },
  plan: {
    color: 'var(--mcg-blue, #015FFB)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '36px' /* 257.143% */,
  },
  header: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '36px' /* 150% */,
    marginBottom: '20px',
  },
})

export default styles
